import { IVehicleAssetsUpdate } from "./interfaces";
import dayjs from "dayjs";

export function UpdateVehicleAssets(this: IVehicleAssetsUpdate) {
  return {
    assetId: this.assetId,
    entityId: this.entityId,
    entityType: this.entityType,
    estimatedValue: this.estimatedValue,
    valuationAmount: this.valuationAmount,
    valuationDate:
      this.valuationDate && dayjs(this.valuationDate).isValid()
        ? dayjs(this.valuationDate).format("YYYY-MM-DD")
        : null,
    description: this.description,
    registrationNo: this.registrationNo,
    yearOrModel: this.yearOrModel,
    comment: this.comment,
  };
}
